import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommunicationApiService {

  apiUrl = environment.apiUrl

  constructor(private http: HttpClient) { }

  storeMessage(data: any) {
    return this.http.post(`${this.apiUrl}communication-store`, data);
  }

  updateMessage(data: any, id: any) {
    return this.http.post(`${this.apiUrl}communication-update/${id}`, data);
  }

  getMessages(page?: number, params?: any) {
    let queryParams = new HttpParams();
    if (page) {
      queryParams = queryParams.set('page', page.toString());
    }
    if (params) {
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (value !== null && value !== undefined && value !== '') {
          queryParams = queryParams.set(key, value);
        }
      });
    }
    return this.http.get(`${this.apiUrl}communication`, { params: queryParams });
  }

  getMessage(id: any) {
    return this.http.get(`${this.apiUrl}communication/${id}`);
  }

  deleteMessage(id: any) {
    return this.http.get(`${this.apiUrl}communication-delete/${id}`);
  }

  updateReadStatus(messageId: any, userId: any) {
    return this.http.post(`${this.apiUrl}communication/reader-update/${messageId}`, { reader_id: userId });
  }


}
